<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
  <div class="subBlockContent" id="financial-summary">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="page-title-wrapper">
          <!-- <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
            <div class="page-title-description">Please find below our quote for an operating lease (rental) for the term requested. Please complete the contact details and end user information below. One of our financing specialists will review and contact you to answer any queries and formalise your quote. 
              The contact may be you or we can contact the end user if preferred.
              If you have any variations to the solution you are building, please go back to the shopping cart to vary your order and re-complete the finance application as often as you like.
            </div>
        </div>

        <div>
          <label class="tablelabel">Application Contact</label>
          <div class="row">
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput placeholder="Name" class="nameinput" [(ngModel)]="name" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput placeholder="Email" class="emailinput" [(ngModel)]="email" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput placeholder="Phone" class="phoneinput" [(ngModel)]="phone" required>
            </mat-form-field>
          </div>
          <label class="tablelabel">Borrower Details</label>
          <div class="row">
            <mat-form-field [floatLabel]="'always'" class="col-md-6">
              <input matInput placeholder="Company Name" class="companyinput" [(ngModel)]="companyName" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" class="col-md-6">
              <input matInput placeholder="Abn" class="abninput" [(ngModel)]="abn">
            </mat-form-field>
          </div>
        </div>

        <div style="margin-top: 20px;">
          <label class="textabel" style="text-transform: capitalize;">Application Reference:  {{quoteName}}</label>
        </div>
        <br />
        <!-- <div>
          <label class="textabel">Terms - {{selectedTerm?.description}} {{selectedTerm?.amount | currency:'AUD':'symbol-narrow':'.2-2'}}/mth </label><br/>
          <label class="textabel">Additional Once Off Charges - {{additionalChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</label><br/>
          <label class="textabel">Monthly Passthrough Recurring Charges - {{passThroughChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</label>
        </div> -->
        <div class="mat-elevation-z8 shared-outer-wrapper">
          <table class="white" style="width: 100%" nowrap>
            <thead>
                <tr class="row cart-title-wrapper">
                  <th scope="col" style="width: 21%; padding-left: 15px">OPTION</th>
                  <th scope="col" class="align-right" style="width: 25%;">FINANCED AMOUNT</th>
                  <th scope="col" class="align-right" style="width: 28%;">MONTHLY RECURRING CHARGES</th>
                  <th scope="col" class="align-right" style="width: 25%; padding-right: 15px">TOTAL REPAYMENTS</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="quote">
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 21%; padding-left: 15px">{{quote.termInMonths}} Rental</td>
                    <td class="align-right" style="width: 25%;">{{ (totalPrice + additionalChargeTotalPrice) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <td class="align-right" style="width: 28%;">{{ (selectedTerm?.amount - passThroughChargeTotalPrice) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <td class="align-right" style="width: 25%; padding-right: 15px">{{ ((selectedTerm?.amount - passThroughChargeTotalPrice) * selectedTerm?.termId) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="passThroughChargeTotalPrice > 0">
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 21%; padding-left: 15px">Monthly Passthrough Charges</td>
                    <td class="align-right" style="width: 25%;"></td>
                    <td class="align-right" style="width: 28%;">{{ passThroughChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <td class="align-right" style="width: 25%; padding-right: 15px">{{ (passThroughChargeTotalPrice * selectedTerm?.termId) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                  </tr>
                </ng-container>
                <ng-container>
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 21%; padding-left: 15px"><b>Total:</b></td>
                    <td class="align-right" style="width: 25%;"></td>
                    <td class="align-right" style="width: 28%;"><b>{{ selectedTerm?.amount | currency:'AUD':'symbol-narrow':'.2-2'}}</b></td>
                    <td class="align-right" style="width: 25%; padding-right: 15px"><b>{{ (selectedTerm?.amount * selectedTerm?.termId) | currency:'AUD':'symbol-narrow':'.2-2'}}</b></td>
                  </tr>
                </ng-container>
              </tbody>
          </table>
        </div>

        <div>
          <label class="tablelabel">Equipment / Service Purchase</label>
          <div class="mat-elevation-z8 shared-outer-wrapper">
            <!-- <mat-table [dataSource]="dataSourceItems">
              <ng-container matColumnDef="SKU">
                <mat-header-cell *matHeaderCellDef> SKU </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.sku}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="DESCRIPTION">
                <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.description}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="QTY">
                <mat-header-cell *matHeaderCellDef class="qty-align"> QTY </mat-header-cell>
                <mat-cell *matCellDef="let element" class="qty-align"> {{element.quantity}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="UNITPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="LINEPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [class.totalprice]="!element.id && financeType != 'enduser'"
                  class="align-right">
                  {{element.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="SELLINGPRICE" *ngIf="financeType == 'enduser'">
                <mat-header-cell *matHeaderCellDef class="align-right"> SELL PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="SELLINGLINEPRICE" *ngIf="financeType == 'enduser'">
                <mat-header-cell *matHeaderCellDef class="align-right"> LINE SELL PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table> -->
            <table class="white" style="width: 100%" nowrap *ngIf="financeType == 'enduser'">
                <thead>
                    <tr class="row cart-title-wrapper">
                      <th scope="col" style="width: 15%; padding-left: 15px">SKU</th>
                      <th scope="col" style="width: 30%;">DESCRIPTION</th>
                      <th scope="col" class="align-center" style="width: 10%;">QTY</th>
                      <th scope="col" class="align-center" style="width: 10%;">UNIT PRICE</th>
                      <th scope="col" class="align-right" style="width: 10%;">LINE PRICE</th>
                      <th scope="col" class="align-right" style="width: 11%;">SELL PRICE</th>
                      <th scope="col" class="align-right" style="width: 13%;">LINE SELL PRICE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let item of shoppingCartItems">
                      <tr class="row product-wrapper product-content-wrapper">
                        <td style="width: 15%; padding-left: 15px">{{item.sku}}</td>
                        <td style="width: 30%; color: #C20047;font-weight: bold;">{{item.description}}</td>
                        <td class="align-center" style="width: 10%;">{{item.quantity}}</td>
                        <td class="align-center" style="width: 10%;">{{item.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                        <td class="align-right" style="width: 10%;">{{item.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                        <td class="align-right" style="width: 11%;">{{item.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                        <td class="align-right" style="width: 13%;"> {{item.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      </tr>
                    </ng-container>
                  </tbody>
            </table>

            <table class="white" style="width: 100%" nowrap *ngIf="financeType != 'enduser'">
              <thead>
                  <tr class="row cart-title-wrapper">
                    <th scope="col" style="width: 15%; padding-left: 15px">SKU</th>
                    <th scope="col" style="width: 35%;">DESCRIPTION</th>
                    <th scope="col" class="align-center" style="width: 14%;">QTY</th>
                    <th scope="col" class="align-center" style="width: 10%;">UNIT PRICE</th>
                    <th scope="col" class="align-right" style="width: 11%;">LINE PRICE</th>
                    <th scope="col" class="align-right" style="width: 15%;padding-right: 15px;">LINE SELL PRICE</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of shoppingCartItems">
                    <tr class="row product-wrapper product-content-wrapper">
                      <td style="width: 15%; padding-left: 15px">{{item.sku}}</td>
                      <td style="width: 35%; color: #C20047;font-weight: bold;">{{item.description}}</td>
                      <td class="align-center" style="width: 14%;">{{item.quantity}}</td>
                      <td class="align-center" style="width: 10%;">{{item.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="align-right" style="width: 11%;">{{item.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="align-right" style="width: 15%;padding-right: 15px;"> {{item.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    </tr>
                  </ng-container>
                </tbody>
          </table>
            <div class="totalrow">
              <p class="totaltext">FINANCED ITEM TOTAL</p>
              <p class="totalprice">{{totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
            </div>
            <!-- <div class="totalrow">
              <p class="totaltext" *ngIf="selectedTerm?.termId!=1">{{selectedTerm?.description}}</p>
              <p class="totalprice" *ngIf="selectedTerm?.termId!=1">{{selectedTerm?.amount | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</p>
              <p class="totaltext-manual" *ngIf="selectedTerm?.termId==1">&nbsp;</p>
              <p class="totalprice-manual" *ngIf="selectedTerm?.termId==1">{{selectedTerm?.description | uppercase}}</p>
            </div> -->
          </div>
        </div>

        <div style="margin-top: 18px;" *ngIf="additionalCharges[0]?.description && financeType == 'enduser'">
          <label class="tablelabel">Additional Once Off Charges</label>
          <div class="mat-elevation-z8 shared-outer-wrapper">
            <!-- <mat-table [dataSource]="dataSourceAdditionalCharge">
              <ng-container matColumnDef="SKU">
                <mat-header-cell *matHeaderCellDef> SKU </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.sku}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="DESCRIPTION">
                <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.description}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="QTY">
                <mat-header-cell *matHeaderCellDef class="align-right"> QTY </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">{{element.quantity}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="UNITPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="LINEPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumnsAdditional"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsAdditional;"></mat-row>
            </mat-table> -->
            <table class="white" style="width: 100%" nowrap>
                <thead>
                    <tr class="row cart-title-wrapper">
                      <th scope="col" style="width: 15%; padding-left: 15px">SKU</th>
                      <th scope="col" style="width: 53%">DESCRIPTION</th>
                      <th scope="col" class="align-center" style="width: 10%">QTY</th>
                      <th scope="col" class="align-center" style="width: 10%">UNIT PRICE</th>
                      <th scope="col" class="align-right" style="width: 10%">LINE PRICE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let charge of additionalCharges">
                      <tr class="row product-wrapper product-content-wrapper">
                        <td style="width: 15%; padding-left: 15px">{{charge.sku}}</td>
                        <td style="width: 53%">{{charge.description}}</td>
                        <td class="align-center" style="width: 10%">{{charge.quantity}}</td>
                        <td class="align-center" style="width: 10%">{{charge.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                        <td class="align-right" style="width: 10%">{{charge.quantity * charge.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      </tr>
                    </ng-container>
                  </tbody>
            </table>
            <div class="totalrow">
              <p class="totaltext">ADDITIONAL ONCE OFF CHARGES TOTAL</p>
              <p class="totalprice">{{additionalChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
            </div>
          </div>
        </div>

        <div style="margin-top: 18px;" *ngIf="passThroughCharges[0]?.description && financeType == 'enduser'">
          <label class="tablelabel">Monthly Passthrough Recurring Charges</label>
          <div class="mat-elevation-z8 shared-outer-wrapper">
            <!-- <mat-table [dataSource]="dataSourcePastThrough">
              <ng-container matColumnDef="SKU">
                <mat-header-cell *matHeaderCellDef> SKU </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.sku}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="DESCRIPTION">
                <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.description}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="QTY">
                <mat-header-cell *matHeaderCellDef class="align-right"> QTY </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">{{element.quantity}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="UNITPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="LINEPRICE">
                <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE </mat-header-cell>
                <mat-cell *matCellDef="let element" class="align-right">
                  {{element.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumnsPass"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumnsPass;"></mat-row>
            </mat-table> -->
            <table class="white" style="width: 100%" nowrap>
                <thead>
                    <tr class="row cart-title-wrapper">
                      <th scope="col" style="width: 15%; padding-left: 15px;">SKU</th>
                      <th scope="col" style="width: 53%">DESCRIPTION</th>
                      <th scope="col" class="align-center" style="width: 10%">QTY</th>
                      <th scope="col" class="align-center" style="width: 10%">UNIT PRICE</th>
                      <th scope="col" class="align-right" style="width: 10%">LINE PRICE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let charge of passThroughCharges">
                      <tr class="row product-wrapper product-content-wrapper">
                        <td style="width: 15%; padding-left: 15px;">{{charge.sku}}</td>
                        <td style="width: 53%">{{charge.description}}</td>
                        <td class="align-center" style="width: 10%">{{charge.quantity}}</td>
                        <td class="align-center" style="width: 10%">{{charge.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                        <td class="align-right" style="width: 10%">{{charge.quantity * charge.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      </tr>
                    </ng-container>
                  </tbody>
            </table>
            <div class="totalrow">
              <p class="totaltext">MONTHLY PASSTHROUGH RECURRING CHARGES</p>
              <p class="totalprice">{{passThroughChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
            </div>
          </div>
        </div>

        <!-- <div class="adjustmargin">
          <label class="tablelabel">Bank Details</label>
          <div class="row">
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput placeholder="NAME" disabled [value]="accountName">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput placeholder="BSB" disabled [value]="bsb">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" class="col-md-4">
              <input matInput placeholder="ACCOUNT" disabled [value]="accountNumber">
            </mat-form-field>
          </div>
        </div> -->
        <!-- <div class="textsection">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus eleifend congue luctus. Fusce scelerisque tincidunt dui. Ut euismod nunc vel purus porta faucibus. Donec volutpat pellentesque augue, non vulputate lorem scelerisque nec. Nulla tortor ante, condimentum sit amet mollis nec, facilisis id turpis. Duis nunc tellus, viverra sit amet tincidunt ac, egestas ut nisl. Maecenas finibus neque eros, eu ornare lorem molestie et. Nunc diam purus, gravida in tincidunt eu, lacinia ac orci. Donec condimentum ac odio ac lobortis. Nullam ut egestas neque, a mattis odio. Nullam sed neque ut mi bibendum vehicula. Curabitur vestibulum eros vitae diam blandit, imperdiet gravida nibh varius. Nunc eget rhoncus nunc, condimentum posuere diam. Etiam id mi vitae augue tincidunt sagittis vitae non odio. Aenean ac sapien quis nisl blandit elementum ac a turpis. Aliquam eget elit eget lectus venenatis lobortis laoreet sed urna. Phasellus sed quam sed tellus scelerisque hendrerit vitae quis lorem. Donec sed metus nulla. Etiam fringilla quam turpis, eu vulputate neque aliquet vitae. In fringilla lorem vestibulum ultricies feugiat.
        </div>

        <div class="adjustmargin">
          <label class="tablelabel">URL</label>
          <input class="qty-input-wrapper" [value]="url">
        </div> -->
        <button class="button button-red button-large middleposition sendquote" (click)="sendQuote()">Send Quote</button>
        <loading-screen *ngIf="!loadContent" [showBlurTable]="false" [isScrolled]="true" backDropWidth="985"
          (currentLoadingStatus)="onLoading($event)"></loading-screen>
      </div>
    </div>
  </div>
</div>